var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.987,
    height: 29.985,
    viewBox: "0 0 29.987 29.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Word",
    transform: "translate(0 0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15709",
    "data-name": "Path 15709",
    d: "M29.362,3.75H17.492V.627A.625.625,0,0,0,16.755,0L.512,3.126A.625.625,0,0,0,0,3.75V26.24a.625.625,0,0,0,.512.612l16.243,3.124h.112a.625.625,0,0,0,.625-.625V26.24h11.87a.625.625,0,0,0,.625-.625V4.375A.625.625,0,0,0,29.362,3.75ZM13.744,10.16l-2.5,9.371a.625.625,0,0,1-.625.462h0a.625.625,0,0,1-.625-.45L8.1,12.821l-1.849,6.11a.575.575,0,0,1-.612.437A.625.625,0,0,1,5,18.894L3.124,11.4a.642.642,0,1,1,1.249-.3L5.7,16.42l1.8-5.985A.737.737,0,0,1,8.121,10a.625.625,0,0,1,.625.45L10.62,17.02l1.874-7.184a.645.645,0,0,1,1.249.325ZM28.737,24.991H17.492V23.117h9.371a.625.625,0,0,0,0-1.249H17.492v-2.5h9.371a.625.625,0,1,0,0-1.249H17.492v-2.5h9.371a.625.625,0,0,0,0-1.249H17.492v-2.5h9.371a.625.625,0,1,0,0-1.249H17.492v-2.5h9.371a.625.625,0,1,0,0-1.249H17.492V5H28.737Z",
    transform: "translate(0 0)",
    fill: "#c4c4c4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/Word.926a26fb16ee175a9596ec8306d950b8.svg";
export { ForwardRef as ReactComponent };